export default __webpack_public_path__ + "static/media/girl1.43862d23.png";